import Slider from 'react-slick'
import styled from 'styled-components'
import PCCaseStudyList, { CaseStudySliderItem } from './PCCaseStudyList'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const settings = {
  dots: true,
  arrows: false,
  className: 'center',
  centerMode: true,
  infinite: true,
  centerPadding: '60px',
  slidesToShow: 1,
  speed: 500,
}

export type CaseStudySliderItems = CaseStudySliderItem[]

interface Props {
  caseStudySliderList: CaseStudySliderItems
}

const CaseStudySliderPC: React.FC<Props> = ({ caseStudySliderList }) => {
  return (
    <SliderWrapper>
      {(() => {
        let single = false
        if (caseStudySliderList.length === 1) {
          single = true
        }
        return (
          <div className={single ? 'single' : ''}>
            <Slider {...settings}>
              {caseStudySliderList.map((caseStudySliderList, index) => (
                <PCCaseStudyList key={index} caseStudySliderList={caseStudySliderList} />
              ))}
            </Slider>
          </div>
        )
      })()}
    </SliderWrapper>
  )
}

const SliderWrapper = styled.div`
  height: 795px;
  border-radius: 8px;
  .slick-dots {
    margin: 20px auto 0;
    position: relative;
    bottom: 0;
    text-align: left;
    @media (max-width: 1199px) {
      padding: 0 24px;
    }
    @media (min-width: 1200px) {
      padding: 0 130px;
      margin: 27px auto 0;
    }
  }

  .slick-dots li {
    width: 40px;
    height: 4px;
    background: #ccc;
    margin: 0 0 0 8px;
    @media (max-width: 719px) {
      width: 32px;
    }
  }

  .slick-dots li:first-child {
    margin: 0;
  }

  .slick-dots li.slick-active {
    background: #db0032;
  }

  .slick-dots li button {
    width: 100%;
    height: 100%;
    padding: 0;
  }

  .slick-dots li button::before {
    content: none;
  }
  .slick-slide > div {
    height: 50%;
  }
`

export default CaseStudySliderPC
